import React from "react";

import { Button } from "../../UI/Button";
import { Box } from "../../UI/Box";
import { Network } from "../../services/NetworkApi";
import { ReadOnlyWrapper } from "../ReadOnlyWrapper";
import { WrapperWithTitle } from "../WrapperWithTitle";
import { TextField } from "../../UI/TextField";
import useAuth from "../../routes/login/AuthContext";

interface IProps {
  l2?: Network | null;
  updateHandler: (key: string, value: string) => Promise<void>;
  isDisabled?: boolean;
}

export const GenderSectionTitle: React.FC<IProps> = (props) => {
  const { isSuperAdminRead } = useAuth();
  const [isLoading, setIsLoading] = React.useState(false);
  const [title, setTitle] = React.useState(props.l2?.genderNetworkSettingsTransport.genderSelectionTitle || "");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTitle(e.target.value);
  };

  React.useEffect(() => {
    if (!props.l2?.genderNetworkSettingsTransport.genderSelectionTitle) return;

    setTitle(props.l2?.genderNetworkSettingsTransport.genderSelectionTitle);
  }, [props.l2?.genderNetworkSettingsTransport.genderSelectionTitle]);

  const handleUpdate = async () => {
    setIsLoading(true);
    await props.updateHandler("genderSelectionTitle", title);
    setIsLoading(false);
  };

  return (
    <WrapperWithTitle title="What title would you like to use for this section?">
      <TextField fullWidth value={title} onChange={handleChange}  isDisabled={props.isDisabled}/>
      <Box mt={1}>
        <ReadOnlyWrapper>
          <Button isLoading={isLoading} appearance="primary" onClick={handleUpdate} isDisabled={isSuperAdminRead() || props.isDisabled}>
            Update
          </Button>
        </ReadOnlyWrapper>
      </Box>
    </WrapperWithTitle>
  );
};
